import * as dat from 'dat.gui';
import { toRegion } from '../@helper/CommonHelper';
import { Environment, IS_DEBUG } from './environment';
import { TaskSource } from './utils/task';
import { getServiceArea } from '@patsnap/common-ps-tracer/src/consts';
import '../vender/dat.gui.module.scss';
const __STORE_KEY__ = '__uni_setting__';
function getRegion() {
    if (Environment.region) {
        return toRegion(Environment.region);
    }
    const area = getServiceArea();
    return toRegion(area);
}
export class UniSetting {
    constructor() {
        // 定义所有环境
        this.passportUrlBase = process.env.VUE_APP_PASSPORT_URI || '';
        this.backofficeUrlBase = `${process.env.VUE_APP_BO_SERVICE_URI}` || '';
        this.marketplaceUrlBase = `${process.env.VUE_APP_MARKETPLACE_SERVICE_URI}/marketplace-api`;
        this.workspaceUrlBase = process.env.VUE_APP_WORKSPACE_SERVICE_URI || '';
        this.analyticsUrlBase = process.env.VUE_APP_ANALYTICS_URI || '';
        this.openApiUrlBase = process.env.VUE_APP_OPENAPI_SERVICE_URI || '';
        this.labUrlBase = process.env.VUE_APP_LAB_SERVICE_URI || '';
        this.toolUrlBase = process.env.VUE_APP_TOOL_SERVICE_URI || '';
        this.cmsUrlBase = process.env.VUE_APP_CMS_SERVICE_URI || '';
        this.eurekaUrlBase = process.env.VUE_APP_EUREKA_URI || '';
        this.taskSource = new TaskSource();
        // 获取当前执行环境 中国 || 国外
        this.region = getRegion() || '';
        // 有用户测试fe_debug数据：https://qa-backoffice.zhihuiya.com/next/?fe_debug=1#/companies
        if (IS_DEBUG) {
            // 显示调试框 调试环境
            this.showControlGui();
        }
        else {
            // 无用户调试数据： https://qa-backoffice.zhihuiya.com/next/#/companies
            // 默认环境配置 => 走ready
            this.taskSource.Resolve(this);
        }
    }
    // 返回Promise 对象
    get Ready() {
        return this.taskSource.Promise;
    }
    /**
     * 调试环境 显示调试框
     * 点击保存自动存储在localStorage dat.gui.__uni_setting__.gui
     */
    showControlGui() {
        window.addEventListener('load', () => {
            localStorage.setItem('dat.gui.namespace', __STORE_KEY__);
            localStorage.setItem('dat.gui.' + __STORE_KEY__ + '.' + 'isLocal', 'true');
            const gui = new dat.GUI({
                load: JSON,
                preset: 'Deafult',
            });
            // 从localStorage 中取值覆盖默认环境配置
            gui.remember(this);
            const fServer = gui.addFolder('Server'); // 添加文件夹
            fServer.add(this, 'passportUrlBase'); // 文件
            fServer.add(this, 'backofficeUrlBase');
            fServer.add(this, 'marketplaceUrlBase');
            fServer.add(this, 'workspaceUrlBase');
            fServer.add(this, 'analyticsUrlBase');
            fServer.add(this, 'openApiUrlBase');
            fServer.add(this, 'labUrlBase');
            fServer.add(this, 'toolUrlBase');
            fServer.add(this, 'region');
            fServer.add(this, 'cmsUrlBase');
            gui.domElement.parentElement.style.zIndex = '10000';
            // 用户修改配置 =>走ready
            this.taskSource.Resolve(this);
        });
    }
}
